<template>
  <div>
    <div id="modalReOrder" class="modal fade" role="dialog" ref="modalReOrder">
      <div class="modal-dialog">
        <div class="modal-content">
          <ValidationObserver ref="form">
            <form @submit.prevent="confirm" method="POST" action>
              <div class="modal-body">
                <div class="content-modal-re-order">
                  <font-awesome-icon
                    icon="times-circle"
                    class="icon-close"
                    @click="onCloseModal()"
                  />
                  <p class="title-modal-re-order">
                    {{ $t('front_end.a095.title') }}
                  </p>
                  <p class="message-re-order">
                    {{ $t('front_end.a095.re_order_message') }}
                  </p>
                  <div class="content-input-re-order row ml-0 mr-0">
                    <div class="col-12 col-md-3 p-0">
                      <span>{{ $t('front_end.a095.order_code') }}</span>
                      <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 col-md-9 p-0">
                      <ValidationProvider
                        mode="passive"
                        :name="$t('front_end.a095.order_code')"
                        rules="required|numeric|half_size|max:16"
                        v-slot="{ errors }"
                        class="width-inherit"
                      >
                        <input
                          class="form-control input-style"
                          v-model.trim="reOrder.orderNo"
                        />
                        <div class="message-error">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="content-input-re-order row ml-0 mr-0">
                    <div class="col-12 col-md-3 m-0 p-0">
                      <span>{{ $t('front_end.a095.name') }}</span>
                      <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 col-md-9 m-0 p-0 row">
                      <div class="col-5 p-0">
                        <ValidationProvider
                          mode="passive"
                          :name="$t('front_end.a095.first_name_holder')"
                          rules="required|max:255|full_size"
                          v-slot="{}"
                          vid="first_name"
                          ref="first_name"
                          class="width-inherit"
                        >
                          <input
                            class="form-control input-style"
                            :placeholder="
                              $t('front_end.a095.first_name_holder')
                            "
                            v-model.trim="reOrder.ordererLastName"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="offset-2 col-5 p-0">
                        <ValidationProvider
                          mode="passive"
                          :name="$t('front_end.a095.last_name_holder')"
                          rules="required|max:255|full_size"
                          v-slot="{}"
                          vid="last_name"
                          ref="last_name"
                          class="width-inherit"
                        >
                          <input
                            class="form-control input-style"
                            :placeholder="$t('front_end.a095.last_name_holder')"
                            v-model.trim="reOrder.ordererFirstName"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="message-error" v-if="errors.name">
                        {{ errors.name }}
                      </div>
                    </div>
                  </div>
                  <div class="content-input-re-order row ml-0 mr-0">
                    <div class="col-12 col-md-3 m-0 p-0">
                      <span>{{ $t('front_end.a095.furigana') }}</span>
                      <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 col-md-9 m-0 p-0 row">
                      <div class="col-5 p-0">
                        <ValidationProvider
                          mode="passive"
                          :name="$t('front_end.a095.first_name_kana_holder')"
                          rules="required|full_size_katakana|max:255"
                          v-slot="{}"
                          ref="first_name_kana"
                          class="width-inherit"
                        >
                          <input
                            class="form-control input-style"
                            :placeholder="
                              $t('front_end.a095.first_name_kana_holder')
                            "
                            v-model.trim="reOrder.kanaLastName"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="offset-2 col-5 p-0">
                        <ValidationProvider
                          mode="passive"
                          :name="$t('front_end.a095.last_name_kana_holder')"
                          rules="required|full_size_katakana|max:255"
                          class="width-inherit"
                          v-slot="{}"
                          ref="last_name_kana"
                        >
                          <input
                            class="form-control input-style"
                            :placeholder="
                              $t('front_end.a095.last_name_kana_holder')
                            "
                            v-model.trim="reOrder.kanaFirstName"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="message-error" v-if="errors.nameKana">
                        {{ errors.nameKana }}
                      </div>
                    </div>
                  </div>
                  <div class="content-input-re-order row ml-0 mr-0">
                    <div class="col-12 col-md-3 p-0">
                      <span>{{ $t('front_end.a095.email') }}</span>
                      <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 col-md-9 p-0">
                      <ValidationProvider
                        mode="passive"
                        :name="$t('front_end.a095.email')"
                        rules="required|email|max:254"
                        v-slot="{ errors, failedRules }"
                        class="width-inherit"
                      >
                        <input
                          class="form-control input-style"
                          v-model.trim="reOrder.mailAddress"
                        />
                        <div v-if="failedRules.email" class="message-error">
                          {{ $t('front_end.a095.validate.email_format') }}
                        </div>
                        <div v-else class="message-error">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="content-input-re-order row ml-0 mr-0">
                    <div class="col-12 col-md-3 m-0 p-0">
                      <span>{{ $t('front_end.a095.phone_number') }}</span>
                      <span class="text-danger">*</span>
                    </div>
                    <div class="col-12 col-md-9 m-0 p-0 row">
                      <ValidationProvider
                        mode="passive"
                        vid="phoneNumberFirst"
                        ref="phoneNumberFirst"
                        :name="$t('front_end.a095.phone_number')"
                        rules="required|min:1|max:5|half_size|numeric"
                        class="col-3 col-md-3 pd-0"
                        v-slot="{}"
                      >
                        <input
                          :type="isMobile ? 'number' : 'text'"
                          class="form-control input-style text-center auto-next"
                          v-model.trim="reOrder.phone1"
                          id="phone_number_first"
                          maxlength="5"
                          :pattern="dynamicPattern"
                        />
                      </ValidationProvider>
                      <span class="line-zip"></span>
                      <ValidationProvider
                        mode="passive"
                        vid="phoneNumberSecond"
                        ref="phoneNumberSecond"
                        :name="$t('front_end.a095.phone_number')"
                        rules="required|min:1|max:4|half_size|numeric"
                        class="col-3 col-md-3 pd-0"
                        v-slot="{}"
                      >
                        <input
                          :type="isMobile ? 'number' : 'text'"
                          class="form-control input-style text-center auto-next"
                          v-model.trim="reOrder.phone2"
                          id="phone_number_second"
                          :pattern="dynamicPattern"
                          maxlength="4"
                        />
                      </ValidationProvider>
                      <span class="line-zip"></span>
                      <ValidationProvider
                        mode="passive"
                        vid="phoneNumberThird"
                        ref="phoneNumberThird"
                        :name="$t('front_end.a095.phone_number')"
                        rules="required|max:4|half_size|numeric"
                        class="col-3 col-md-3 pd-0"
                        v-slot="{}"
                      >
                        <input
                          :type="isMobile ? 'number' : 'text'"
                          class="form-control input-style text-center auto-next"
                          v-model.trim="reOrder.phone3"
                          id="phone_number_third"
                          :pattern="dynamicPattern"
                          maxlength="4"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-12 col-md-3 m-0 p-0"></div>
                    <p
                      class="col-12 col-md-9 message-error"
                      v-if="errors.phone"
                    >
                      {{ errors.phone }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="row-search">
                <button class="btn-confirm-re-order col-6">
                  {{ $t('front_end.a095.continue') }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <!-- base alert -->
    <fe-alert ref="alertError" :datas="dataAlert">
      <template v-slot:default>
        <font-awesome-icon
          icon="times-circle"
          class="icon-close"
          @click="closeAlert()"
        />
        <div class="form-group text-center cursor-default">
          <div
            class="mt-4 error-re-order"
            v-html="$t('front_end.a095.order_exits')"
          />
        </div>
      </template>
    </fe-alert>
  </div>
</template>

<script>
import JQuery from 'jquery'
import apiService from '@/services/api'
import apiEndpoints from '@/services/apiEndpoints'
import { mapGetters } from 'vuex'
import FeAlert from '@/components/fe/common/FeAlert'
import deviceUtil from '../../utils/deviceUtil'
//var md5 = require('md5')

export default {
  name: 'a095',
  components: {
    FeAlert,
  },
  data() {
    return {
      dataAlertA095: {
        isShow: false,
        isShowClose: true,
        content: this.$t('front_end.a095.order_exits'),
        opts: { backdrop: 'static', keyboard: false },
        showCenterDevice: true,
      },
      errors: {
        orderNumber: '',
        name: '',
        nameKana: '',
        email: '',
        phone: '',
      },
      isError: false,
      reOrder: {
        orderNo: '',
        ordererFirstName: '',
        ordererLastName: '',
        kanaFirstName: '',
        kanaLastName: '',
        mailAddress: '',
        phone1: '',
        phone2: '',
        phone3: '',
      },
      messageError: this.$t('front_end.a095.order_exits'),
      isMobile: !deviceUtil.isPc(),
      dataAlert: {
        isShow: false,
        isShowClose: false,
        opts: {
          keyboard: false,
          backdrop: 'static',
        },
        modalClass: 'a095confirm',
      },
      isPhoneError: false,
    }
  },
  computed: {
    ...mapGetters(['shopMode']),
    phoneNumber() {
      return this.reOrder.phone1 + this.reOrder.phone2 + this.reOrder.phone3
    },
    dynamicPattern() {
      return deviceUtil.isiOS() ? '\\d*' : '.*'
    },
  },
  created() {
    this.clearSesison()
    document.addEventListener('keydown', function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === 'input') {
        e.preventDefault()
      }
    })
  },
  mounted() {
    JQuery('#modalReOrder').modal(this.dataAlertA095.opts)
    JQuery('#modalReOrder').modal('show')
  },
  methods: {
    hide() {
      JQuery('#modalReOrder').modal('hide')
    },
    onCloseModal() {
      this.hide()
      this.$router.push({ name: 'a005' })
    },
    closeAlert() {
      this.$refs.alertError.hide()
      // this.isError = false;
    },
    async confirm() {
      let isValidPhone = this.checkPhoneIsValid()
      let isValid = await this.validateForm()
      if (!isValid || !isValidPhone) {
        return ''
      }
      let url = apiEndpoints.getOrderedImage
      let param = { orderingInformation: this.reOrder }
      try {
        let result = await apiService.post(url, param)
        if (result && result.data) {
          // レスポンスデータの名称はimageDataですが再注文用のトークンが返却されます
          let orderToken = result.data.imageData
          this.clearSessionReOrder()
          let orderNo = this.reOrder.orderNo
          this.$store.commit('userData/SET_ORDER', {
            reOrder: orderNo,
          })
          this.hide()
          this.$router.push({
            name: 'a110',
            params: { orderNo: orderToken },
          })
        } else {
          this.showAlert()
        }
      } catch (e) {
        this.showAlert()
      }
    },
    async validateForm() {
      this.isPhoneError = !this.checkPhoneIsValid()
      let isValid = await this.$refs['form'].validate()
      this.validateCustom()
      return isValid || this.isPhoneError
    },
    validateCustom() {
      let providerName = null
      if (
        this.$refs.last_name?.errors &&
        this.$refs.last_name.errors.length > 0
      ) {
        providerName = this.$refs.last_name.failedRules
      } else if (
        this.$refs.first_name?.errors &&
        this.$refs.first_name.errors.length > 0
      ) {
        providerName = this.$refs.first_name.failedRules
      }

      let providerFuri = null
      if (
        this.$refs.last_name_kana?.errors &&
        this.$refs.last_name_kana.errors.length > 0
      ) {
        providerFuri = this.$refs.last_name_kana.failedRules
      } else if (
        this.$refs.first_name_kana?.errors &&
        this.$refs.first_name_kana.errors.length > 0
      ) {
        providerFuri = this.$refs.first_name_kana.failedRules
      }

      let providerPhone = null
      if (
        this.$refs.phoneNumberFirst?.errors &&
        this.$refs.phoneNumberFirst.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberFirst.failedRules
      } else if (
        this.$refs.phoneNumberSecond?.errors &&
        this.$refs.phoneNumberSecond.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberSecond.failedRules
      } else if (
        this.$refs.phoneNumberThird?.errors &&
        this.$refs.phoneNumberThird.errors.length > 0
      ) {
        providerPhone = this.$refs.phoneNumberThird.failedRules
      }

      const errorMes = {
        name: {
          required:
            this.$t('front_end.a035.label.name') +
            this.$t('front_end.a035.validate.required'),
          full_size: this.$t('front_end.a035.validate.name_format'),
        },
        nameKana: {
          required:
            this.$t('front_end.a035.label.name_furigana') +
            this.$t('front_end.a035.validate.required'),
          full_size_katakana:
            this.$t('front_end.a035.label.name_furigana') +
            this.$t('front_end.a035.validate.name_furigana_format'),
        },
        phone: {
          required:
            this.$t('front_end.a095.phone_number') +
            this.$t('front_end.a035.validate.required'),
          min:
            this.$t('front_end.a095.phone_number') +
            this.$t('front_end.a035.validate.length'),
          half_size: this.$t('front_end.a035.validate.phone_number_format'),
          numeric: this.$t('front_end.a035.validate.phone_number_format'),
        },
      }

      if (providerName) {
        if (providerName.required) {
          this.errors.name = errorMes.name.required
        } else if (providerName.full_size) {
          this.errors.name = errorMes.name.full_size
        }
      } else {
        this.errors.name = ''
      }
      if (providerFuri) {
        if (providerFuri.required) {
          this.errors.nameKana = errorMes.nameKana.required
        } else if (providerFuri.full_size_katakana) {
          this.errors.nameKana = errorMes.nameKana.full_size_katakana
        }
      } else {
        this.errors.nameKana = ''
      }
      if (providerPhone) {
        if (providerPhone.required) {
          this.errors.phone = errorMes.phone.required
        } else if (providerPhone.min) {
          this.errors.phone = errorMes.phone.min
        } else if (providerPhone.half_size) {
          this.errors.phone = errorMes.phone.half_size
        } else if (providerPhone.numeric) {
          this.errors.phone = errorMes.phone.numeric
        }
      }
    },
    clearSessionReOrder() {
      this.$store.dispatch('userData/clearSession')
      this.$store.dispatch('userData/clearSessionReOrder')
    },
    checkPhoneIsValid() {
      if (this.phoneNumber.length < 10 || this.phoneNumber.length > 11) {
        this.errors.phone = this.$t(
          'front_end.a095.validate.phone_number_limit'
        )
        return false
      } else {
        this.errors.phone = ''
        return true
      }
    },
    setHolderNameErrorsIfExists() {
      // get name Errors
      let holderNameErrors =
        this.$refs.holderFirstName.errors.length !== 0
          ? this.$refs.holderFirstName.errors
          : this.$refs.holderLastName.errors

      this.errors.holderName =
        holderNameErrors.length !== 0 ? holderNameErrors[0] : ''
    },

    showAlert() {
      this.$refs.alertError.show()
      JQuery('.modal-backdrop:last').css('z-index', '1050') // hidden all other modal
      // this.isError = true;
    },
    clearSesison() {
      this.$store.dispatch('reOrder/clearSession')
    },
    focusPhone(e) {
      if (e.target.value.length == Number(e.target.dataset.max)) {
        document.getElementById(e.target.dataset.nextElement).focus()
      }
    },
  },
}
</script>

<style scoped src="../../assets/css/splash/splash.css"></style>

<style scoped>
.message-error {
  font-size: 11px;
}
.message-error-size,
.inline-error-noti {
  font-size: 12px;
}
@media screen and (max-width: 768px) {
  .message-error-size,
  .inline-error-noti,
  .message-error {
    font-size: 11px;
  }
}
.form-control {
  font-size: 0.9rem;
  line-height: 1.6;
}
.alert-center {
  text-align: center;
  padding: 15px;
}
.pd-0 {
  padding: 0px !important;
}
.modal-open .modal {
  overflow-x: unset !important;
  overflow-y: unset !important;
  padding: 0 15px !important;
}
.modal-dialog {
  margin-top: unset !important;
}
.modal-content {
  border-radius: 5px;
}
.error-dialog {
  padding-top: 100px;
}
.error-re-order {
  padding: 40px;
}

#feAlert {
  z-index: 1060;
}
@media (min-width: 576px) {
  .modal {
    top: 15px;
  }
}
@media (max-width: 768px) {
  .modal-dialog {
    padding-top: 20px !important;
  }
}
@media (max-width: 576px) {
  .modal-dialog {
    padding-top: 30px !important;
    overflow-y: auto;
    max-height: calc(100vh - 30px);
  }
}
</style>
<style scope>
.a095confirm .dialog-content .modal-body {
  padding: 1.5rem !important;
}
.a095confirm .modal-dialog {
  margin: 150px auto !important;
  padding: 10px;
}
</style>
